export var ActivityWalletCreateProcessStatusType;
(function (ActivityWalletCreateProcessStatusType) {
    ActivityWalletCreateProcessStatusType["PENDING"] = "pending";
    ActivityWalletCreateProcessStatusType["PROCESSING"] = "processing";
    ActivityWalletCreateProcessStatusType["FAILED"] = "failed";
})(ActivityWalletCreateProcessStatusType || (ActivityWalletCreateProcessStatusType = {}));
//# sourceMappingURL=ActivityWalletCreateProcessStatusType.js.map